import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import moment from "moment";
import ws from "./services/webSocket";
import axios from "axios";
import Vidle from "v-idle";

Vue.config.productionTip = false;

if (
  window.location.hostname == process.env.VUE_APP_PROD_HOSTNAME ||
  process.env.VUE_APP_PROD_CNAME
) {
  store.dispatch("setURL", "https://func-gcas-prod.azurewebsites.net/api");
  store.dispatch(
    "setScope",
    "api://796d5d1d-78d4-4dda-a4c5-fb589e5beb59/.default"
  );
} else if (
  window.location.hostname == process.env.VUE_APP_STAGE_HOSTNAME ||
  process.env.VUE_APP_STAGE_CNAME
) {
  store.dispatch("setURL", "https://func-gcas-stage.azurewebsites.net/api");
  store.dispatch(
    "setScope",
    "api://790cd816-2cb9-4688-acbf-4678ddcd44f6/.default"
  );
} else {
  store.dispatch("setURL", "https://func-gcas-dev.azurewebsites.net/api");
  store.dispatch(
    "setScope",
    "api://1cb26cf7-5afc-462c-b5a2-d9a90fb232da/.default"
  );
}

Vue.filter("formatDate", (value) => {
  return moment(value, "YYYY-MM-DD").format("L");
});

Vue.filter("formatDay", (value) => {
  return moment(value, "YYYY-MM-DD").format("dddd");
});

Vue.prototype.$moment = moment;
Vue.prototype.$ws = ws;
Vue.prototype.$http = axios;

Vue.use(Vidle);

router.beforeEach(async (to, from, next) => {
  await store.dispatch("accounts/handleLoginRedirect");
  const account = store.getters["accounts/getAccount"];
  const apiURL = store.state.apiURL

  if (apiURL && account?.username) {
    try {
      await ws.client({ apiURL, userId: account.username });
    } catch (e) {
      console.warn("WS init error:", e);
    }
  }

  next();
});

ws.onMessage((msg) => {
  // Log every incoming message for debugging
  console.log("📩 Incoming WS message (raw):", msg);

  let data;
  try {
    data = typeof msg === "string" ? JSON.parse(msg) : msg;
  } catch {
    data = msg;
  }

  if (data.message === 'Case created!' || data.message === 'Case updated!') {
    if (!store.state.cases.loading && !document.hidden) {
      // Uncomment if you want to refresh cases automatically:
      // store.dispatch('cases/getCases');
    }
  }
  if (data.snackbar) {
    store.dispatch('snackbar/showSnack', { snackbar: true, message: data.task });
  }
  if (data.task) {
    store.dispatch('snackbar/showSnack', { snackbar: true, message: data.task });
    store.dispatch('setLoading', false);
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
